import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { flexCenter } from '@ecp/common/src/style/theme/defaultStyled';
import theme from '@ecp/common/src/style/theme/default';
import { ReactComponent as ChipClose } from '@ecp/common/src/assets/icon/icon__chip-close.svg';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

export const checkedChipStyle = css`
  ${({ check }) => check}
`;

const ChipTextBox = styled(FlexBox)`
    max-width: 100px;
    white-space: nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
`;

export const StyledChipButton = styled.button.attrs(
  ({ width = 'max-content', height = '30px', borderRadius = `calc(${height} / 2)`, style, closable }) => ({
    style: {
      ...style,
      width,
      height,
      borderRadius,
      closable,
    },
  })
)`
  ${flexCenter};
  gap: 3px;
  font-size: 12px;
  min-width: 50px;
  min-height: 30px;
  padding: 0 12px;
  cursor: pointer;
  background-color: #f7f7f7;
  border-color: ${({ border = theme.color.line.selected }) => border};
  &:hover {
    background-color: ${theme.color.background.disabled};
  }

  ${({ checked }) => checked && checkedChipStyle};
  ${({ closable }) => closable && `border: 1px solid #141415; background-color: #ffffff;`};
`;

export const StyledChipClose = styled(ChipClose)`
  width: 10px;
  height: 10px;
`;

const ChipSearch = ({ closeIcon: CloseIcon, closable, children, onClick, onClose, ...props }) => {
  return (
    <StyledChipButton
      {...props}
      onClick={onClick}
      type={'button'}
      title={props.checked ? '선택됨' : ''}
      closable={closable}
    >
      <ChipTextBox maxWidth={'100px'}  white-space={'nowrap'} overflow={'hidden'} text-overflow={'ellipsis'}>
      {children}
      </ChipTextBox>
      {closable && (
        <CloseIcon
          {...props}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      )}
    </StyledChipButton>
  );
};

ChipSearch.displayName = 'ChipSearch';

ChipSearch.propTypes = {
  closeIcon: PropTypes.elementType,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  checked: PropTypes.bool,
  closable: PropTypes.bool,
  children: PropTypes.array,
};

ChipSearch.defaultProps = {
  type: 'default',
  closeIcon: StyledChipClose,
  onClose: () => {},
  closable: true,
};

export default ChipSearch;
